// extracted by mini-css-extract-plugin
module.exports = {"navbar":"SpotChorusIntegration_navbar__1FWVa","loading":"SpotChorusIntegration_loading__3aLSR","sofDocument":"SpotChorusIntegration_sofDocument__3ODhD"};